module.exports = __webpack_public_path__ + "static/media/challenge-background-tasks-mountains.f6e9e03d.svg";